var fieldIsValid = function (el) {
    var errorSection = $(el).closest(".form-group").find(".error-message");
    if (!$(el).val()) {
        errorSection.removeClass("d-none");
        return false;
    }
    else {
        errorSection.addClass("d-none");
        var isEmailWithError = $(el).is('input[type="email"]') && $(el).is(':valid') === false;
        return isEmailWithError === false;
    }
};

var checkFormValid = function () {
    var allFieldsValid = true;
    $(".requiredInput").each(function (idx, el) {
        if (fieldIsValid(el) === false) {
            allFieldsValid = false;
        }
    });
    if (allFieldsValid === false) {
        $("#mainError").removeClass("d-none");
    }
    else {
        $("#mainError").addClass("d-none");
    }
    return allFieldsValid;
};

$(document).ready(function () {
    // Validate whenever anything changes
    $("input").on("blur change keyup", function () {
        fieldIsValid($(this));
    });

    if (window.validationNeeded) {
        checkFormValid();
    }

    // Button Spinner and validation
    $('form').on("submit", function (event) {
        setTimeout(function () { $('.js-submitButton').attr("disabled", true); }, 0);
        $('.js-submitButtonSpinner').removeClass("d-none");

        if (checkFormValid() === false) {
            event.preventDefault();
            setTimeout(function () { $('.js-submitButton').attr("disabled", false); }, 0);
            $('.js-submitButtonSpinner').addClass("d-none");
        }
    });
});
